import { ControlTypes } from '../../generic-form/enums/control-types';

export function getEditorRawValue(args?: any): any {
  const editor = args?.editor;
  if (!editor) return undefined;
  if (typeof editor.getValue === 'function') {
    const value = editor.getValue();
    if (typeof value === 'string') {
      return value;
    }
  }

  const rawInput = (editor as any).input ?? (editor as any).$input?.[0] ?? (editor as any).$input;
  if (rawInput && typeof rawInput.value !== 'undefined') {
    return rawInput.value;
  }

  if (typeof (editor as any).$input?.val === 'function') {
    return (editor as any).$input.val();
  }

  return undefined;
}

export function normalizeValueForRequired(value: any, controlType: string, args?: any): any {
  const isTextField = controlType === ControlTypes.Textbox;
  if (!isTextField || typeof value !== 'string') {
    return value;
  }

  const trimmed = value.trim();
  if (args?.editor && trimmed !== value) {
    args.editor.setValue(trimmed);
  }
  return trimmed;
}
